import { Avatar, Box, CardHeader, IconButton } from "@mui/material";
import * as React from "react";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { useMode } from "../../theme";
import { VideoContext } from "../../context/video_context";
import { MoreVert } from "@mui/icons-material";
import { red } from "@mui/material/colors";
// import { useAuth0 } from "@auth0/auth0-react";
import useAuth from "../../hooks/auth_hook";
import moment from "moment";

export type Video = {
  imgLink: string;
  title: string;
  views: string;
  uploaded: Date;
  video_id: string;
  handlePageChangeUp?: any;
};
const calculateDaysHoursYearsAgo = (date: Date) => {
  const now = new Date();
  const then = new Date(date);
  // console.log({ now, date })
  const diff = now.getTime() - then.getTime();
  const seconds = Math.floor(diff / 1000);
  const minutes = Math.floor(diff / (1000 * 60));
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));
  if (years > 0) {
    return `${years} years ago`;
  }
  if (days > 0) {
    return `${days} days ago`;
  }
  if (hours > 0) {
    return `${hours} hours ago`;
  }
  if (minutes > 0) {
    return `${minutes} minutes ago`;
  }
  return `${seconds} seconds ago`;
};
export default function VideoCard(fn: Video) {
  const [theme, colorMode] = useMode();
  const videoContext = React.useContext(VideoContext);
  const setSelectedVideo = videoContext?.setSelectedVideo || (() => {
  });
  const { user, isAuthenticated } = useAuth();

  return (
    <Box sx={{ borderRadius: "16px", height: "100%", width: "100%" }}>
      <CardActionArea onClick={() => {
        setSelectedVideo(fn.video_id);
        fn.handlePageChangeUp();
      }}>
        <CardMedia sx={{
          borderRadius: "16px", padding: "0px", margin: "0px"
        }} component="img" height="100%" image={fn.imgLink} alt="Thumbnail for Youtube Video titled: " />
        <CardHeader
          avatar={
            <Avatar src={user?.user_metadata?.user_metadata} aria-label="recipe"
                    sx={{ height: "30px", width: "30px" }}>
            </Avatar>
          }
          title={fn.title}
          subheader={<>
            <span>{fn.views} views</span> • <span>{calculateDaysHoursYearsAgo(fn.uploaded)}</span></>}
        />
      </CardActionArea>
    </Box>
  );
}

export type Test = {
  imgLink: string;
  title: string;
  video_id: string;
  filename: string;
  duration: number;
  order: number;
  handlePageChangeUp?: any;
  loadFromImgLink?: boolean;
  active?: boolean;
  activated?: string;
  deactivated?: string;
  tested?: boolean;
  time_to_test?: string;
};

export function TestCard(fn: Test) {
  const [theme, colorMode] = useMode();
  const videoContext = React.useContext(VideoContext);
  const setSelectedVideo = videoContext?.setSelectedVideo || (() => {
  });
  const { user, isAuthenticated } = useAuth();
  // console.log({user, isAuthenticated})
  // console.log(user?.user_metadata?.full_name)
  const getTestTime = () => {
    return (fn?.active && fn?.activated) ? new Date(fn?.activated) : fn?.time_to_test ? new Date(fn?.time_to_test) : new Date(new Date().getTime() + fn.order * fn.duration * 1000);
  };
  const getDateStart = () => {
    const now = getTestTime();
    //Add order*duration seconds to now
    const then = new Date(new Date().getTime() + fn.order * fn.duration * 1000);
    // Return in format, Weekday, Time
    return moment(now).format("ddd, h:mm a");
  };
  const getDateEnd = () => {
    const now = getTestTime();
    //Add order*duration seconds to now
    const then = new Date(now.getTime() + (fn.order + 1) * fn.duration * 1000);
    // Return in format, Weekday, Time
    return moment(then).format("ddd, h:mm a");
  };
  return (
    <Box sx={{ borderRadius: "8px", height: "100%", width: "100%" }}>
      <CardActionArea onClick={() => {
        setSelectedVideo(fn.video_id);
        fn.handlePageChangeUp();
      }}>
        <Box sx={{ backgroundColor: "black", borderRadius: "16px" }}>
          <img
            src={fn.imgLink}
            style={{
              width: "100%", objectFit: "contain",
              borderRadius: "16px",
              maxHeight: "200px"
            }}
            alt="Thumbnail for Youtube Video titled: "
          />
        </Box>
        <CardHeader
          avatar={
            <Avatar src={user?.user_metadata?.avatar_url} aria-label="recipe"
                    sx={{ height: "30px", width: "30px" }}>
            </Avatar>
          }
          title={fn.title}
          subheader={<><span>
              {getDateStart()}
              </span> - <span>{getDateEnd()}</span></>}
        />
      </CardActionArea>
    </Box>
  );
}

export function LargeVideoCard(fn: Video | Test) {
  const [theme, colorMode] = useMode();
  return (
    <Box
      sx={{
        paddingY: "10px",
        paddingX: "10px",
        display: "flex",
        flexDirection: "column"
      }}
    >
      <Card sx={{ minWidth: 300, maxHeight: 340 }}>
        <CardActionArea>
          <CardMedia
            component="img"
            height="100%"
            image={"filename" in fn ? fn.imgLink : process.env.PUBLIC_URL + fn.imgLink}
            alt="Thumbnail for Youtube Video titled: "
            sx={{ padding: 0, borderRadius: "10px" }}
          />
          <CardContent sx={{ paddingY: "8px" }}>
            <Typography variant="h6" component="div" sx={{ paddingY: 0 }}>
              {fn.title}
            </Typography>
            <Box
              sx={{
                display: "flex",
                paddingY: "4px",
                marginY: 0
              }}
            >
              <Typography
                sx={{ whiteSpace: "nowrap" }}
                variant="body2"
                color="text.secondary"
              >
                {"views" in fn ? `${fn.views} views` : "Test Content"}
              </Typography>
              <Typography sx={{ marginX: "4px", whiteSpace: "nowrap" }}>
                •
              </Typography>
              <Typography
                sx={{ whiteSpace: "nowrap" }}
                variant="body2"
                color="text.secondary"
              >
                {"duration" in fn ?
                  (fn.duration < 3600 ? `${fn.duration / 60} minutes` :
                    fn.duration < 86400 ? `${fn.duration / 3600} hours` :
                      fn.duration < 604800 ? `${fn.duration / 86400} days` :
                        `${fn.duration / 604800} weeks`)
                  : `${fn.uploaded}`}
              </Typography>
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Box>
  );
}
